
import './App.css';
import {BrowserRouter} from "react-router-dom";
import {Route, Routes} from "react-router-dom";
import HomePage from "./screens/home/HomePage";
import Dashboard from "./screens/dashboard/Dashboard";
import AdminLogin from "./screens/admin-login/AdminLogin";
import SiteUnavailable from "./screens/maint/SiteUnavailable";

function App() {

    return (
        <div className="App">

          <BrowserRouter>
            <Routes>
                <Route path="/unavailable" element={<SiteUnavailable/>}/>
                <Route path="/" element={<HomePage/>}/>
                <Route path="/admin-dashboard" element={<Dashboard/>}/>
                <Route path={"/admin-login"} element={<AdminLogin/>}/>
            </Routes>
          </BrowserRouter>

        </div>
    );
}

export default App;
